<template>
  <div class="agr">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <!-- banner -->
    <div class="banner">
      <img src="/imgs/info2.jpg" alt="" />
    </div>

    <div class="container">
      <!-- 容器 -->
      <div class="info2-list">
        <!-- 标题 -->
        <h2>商务经理</h2>
        <p>岗位职责：</p>
        <p>
          1，协助总经理推进公司全面的业务工作，辅助总经理处理公司日常对外商务性工作的跟踪，协调和汇报。
        </p>
        <p>
          2，负责公司现有销售项目的客情关系维护并促进其良好的执行发展进而提升销售业务量；
        </p>
        <p>3，拓展，开发全新的业务渠道，负责新销售渠道的构建和商业渠道的推广；</p>
        <p>
          4，搜寻掌握行业内动态，及时关注大型企业招投标项目，统筹商务投标文件，标书制作及日常商务文件整理。
        </p>
        <p>5，负责辅助总经理完成对现行项目的监督和管理工作和其他机动性工作。</p>

        <div class="br"></div>

        <p>任职要求：</p>
        <p>1，注重仪容仪表，深谙商务礼节，具备优秀的沟通交流能力和外向型公关能力不抵触陌生拜访。</p>
        <p>2，性格积极乐观，团结友爱，具备较好的文字写作功底，熟练操纵办公软件。</p>
        <p>3，稳定，敬业。</p>

      </div>



       <!-- 容器 -->
      <div class="info2-list">
        <!-- 标题 -->
        <h2>动漫设计</h2>
        <p>岗位职责：</p>
        <p>
          1. 根据编辑计划设计制作完成相关的宣传内容；
        </p>
        <p>
        2. 能独立开发选题并制作完成多类型宣传内容；
        </p>
        <p>3. 能根据客户需求提供相应的内容及品牌服务。</p>
        

        <div class="br"></div>

        <p>岗位要求: </p>
        <p>1. 专科及以上学历，文字编辑、平面设计、视频制作等相关专业毕业；</p>
        <p>2. 熟练使用MAYA、C4D、Photoshop、Premiere、AE等图像设计、视频编辑类软件，有手绘、动漫、动画、flash、H5等设计制作能力；</p>
        <p>3. 三年以上媒体相关经验，有策划、设计、编辑、制作的作品和案例；</p>
        <p>4. 年龄30岁以下，男女不限，户口不限；</p>

      </div>
      
      <h4>简历投递：请将简历和作品发送至hr@jjwx.com（邮件标题：应聘岗位+姓名）</h4>
      <h4>工作地址：北京市朝阳区北苑路5号</h4>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/h2";
export default {
  name: "agreement",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "北京晋江奇境网络科技有限公司 ";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.agr {
  padding-bottom: 40px;
    box-sizing: border-box;
  .banner {
    width: 100%;
    height: 570px;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .container {
    width: 980px;
    padding-top: 30px;
    padding-bottom: 40px;
    box-sizing: border-box;
    border-bottom: 4px solid #ccc;
    h4 {
      margin: 25px 0;
    }
    .info2-list {
      background-color: #f6f6f6;
      margin: 30px 0;
      h2 {
        width: 100%;
        height: 66px;
        border-left: 8px solid #c60023;
        font-size: 18px;
        padding-left: 52px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-bottom: 20px;
      }

      p {
        padding-left: 18px;
        box-sizing: border-box;
        font-size: 14px;
        color: #333;
        margin: 10px 0;
        line-height: 21px;
      }
      
      .br {
        margin:30px 0;
      }
    }

  }
}
</style>
